import { UI_LOCALES } from '@/i18n/uiStrings';
import type { Locale, RequestStatus } from '@/types/api.types';

export function formatDateTime(iso: string | null | undefined, lang: Locale): string {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat(UI_LOCALES[lang], { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function formatDate(iso: string | null | undefined, lang: Locale): string {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat(UI_LOCALES[lang], { dateStyle: 'medium' }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1_048_576) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1_048_576).toFixed(1)} MB`;
}

export const statusColor: Record<RequestStatus, 'info' | 'warning' | 'success' | 'default' | 'error'> = {
  RECEIVED: 'info',
  IN_REVIEW: 'warning',
  ANSWERED: 'success',
  CLOSED: 'default',
  REJECTED: 'error',
};

export const TRACKING_CODE_RE = /^JS-[A-Z2-9]{4}-[A-Z2-9]{4}$/;

export function getInitials(first?: string, last?: string): string {
  return `${first?.[0] ?? ''}${last?.[0] ?? ''}`.toUpperCase() || '?';
}
